import {RootState} from '../../store';

const key = 'dnsRecords';

// FNP-1293 — the selection slice, keyed by `recordKey(name, type)` rather than
// an id, because a DNS record has none. See reducers/index.ts.
export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};
